import { Button, Tooltip } from '@material-ui/core';
import SaveAltIcon from '@material-ui/icons/SaveAlt';
import NotificationProvider from 'components/NotificationProvider';
import { useState } from 'react';
import { useBulkExportCostReportMutation } from 'features/vehicles/vehicleSlice';
import CostReportExportModal from './CostReportExportModal';

// SCN-403 — Bulk export action rendered in DataTable's BulkActionsToolbar.
// DataTable automatically passes `selectedRows` (array of row IDs) to bulk action components.
const BulkCostReportExport = ({ selectedRows = [] }) => {
    const [open, setOpen] = useState(false);
    const [bulkExport, { isLoading: isExporting }] = useBulkExportCostReportMutation();

    const handleExport = async ({ dateStart, dateEnd, categories }) => {
        const result = await bulkExport({
            vehicleIds: selectedRows,
            dateStart,
            dateEnd,
            categories,
        });

        if (result?.error) {
            NotificationProvider.error('Failed to export cost reports');
            return;
        }

        setOpen(false);
    };

    if (selectedRows.length < 2) return null;

    return (
        <>
            <Tooltip title="Coming soon" placement="top">
                <span>
                    <Button
                        onClick={() => setOpen(true)}
                        style={{ padding: '0.5em 1.5em', fontSize: '0.8em' }}
                        disabled
                    >
                        <div style={{ color: 'rgba(0, 0, 0, 0.26)' }}>
                            <div>
                                <SaveAltIcon className="icon" style={{ fill: 'rgba(0, 0, 0, 0.26)' }} />
                            </div>
                            <div>Cost Report</div>
                        </div>
                    </Button>
                </span>
            </Tooltip>
            <CostReportExportModal
                open={open}
                onClose={() => setOpen(false)}
                onExport={handleExport}
                isExporting={isExporting}
            />
        </>
    );
};

export default BulkCostReportExport;
